import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';


const ColorMapLegend = props => {
  const { items = [], title = '' } = props;

  return (
    <Box p={0.5} marginLeft={0.5}>
      {title &&
        <Typography variant="subtitle1" gutterBottom>
          {title}
        </Typography>
      }

      {items.map((item, index) => (
        <Box key={index} display="flex" alignItems="center" mb={0.5}>
          <Box
            sx={{
              width: 16,
              height: 16,
              bgcolor: item.color,
              border: '1px solid #000',
              marginRight: 5,
            }}
          />
          <Typography variant="body2">{item.label}</Typography>
        </Box>
      ))}
    </Box>
  );
};

ColorMapLegend.propTypes = {
  items: PropTypes.array,
  title: PropTypes.string,
};


export {
  ColorMapLegend,
};

